module.exports = __webpack_public_path__ + "static/img/jb_pic4.48fa065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jb_pic4.jpg
// module id = d0GG
// module chunks = 5